var _path, _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPeLogo = function SvgPeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.419.289c4.645 0 8.418 3.77 8.418 8.419 0 3.107-1.702 5.792-4.208 7.25v6.13l-4.21-2.104-4.21 2.105v-6.13C1.703 14.5 0 11.815 0 8.708A8.42 8.42 0 0 1 8.419.288Zm0 12.628a4.21 4.21 0 1 0 .001-8.419 4.21 4.21 0 0 0-.001 8.42Z",
    fill: "#09ABAB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.35,
    y: 9.216,
    width: 7.047,
    height: 2.29,
    rx: 1.145,
    fill: "#09ABAB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.35,
    y: 13.732,
    width: 9.732,
    height: 2.29,
    rx: 1.145,
    fill: "#09ABAB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.35,
    y: 4.701,
    width: 9.732,
    height: 2.29,
    rx: 1.145,
    fill: "#09ABAB"
  })));
};

export default SvgPeLogo;